import { IFormatter } from './interfaces';
import { CurrencyFormatter } from './currency';
import { DateFormatter } from './date';
import { DecimalFormatter } from './decimal';

export class Formatter {

  private static _formatterMap: { [key: string]: () => IFormatter<object> } = {
    'currency': () => new CurrencyFormatter(),
    'decimal': () => new DecimalFormatter(),
    'date': () => new DateFormatter(),
  };

  static format(value: string | number, type: string, options?: any) {

    const formatter = this._formatterMap[type];
    if (formatter) {
      return formatter().format(value, options);
    }

    return value;
  }
}
